import React from "react";
import { RiseUserAction } from "@/types/RiseUserAction";
import { getActionTheme } from "../RiseAction/util";
import { USER_ACTION_METRICS } from "@/api/queries/userActionMetrics";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

export const Metrics = ({ action }: { action: RiseUserAction }) => {
  const theme = getActionTheme(action.actionGroup);

  // this gets refetched when user statuses are updated
  const { data } = useQuery(USER_ACTION_METRICS, {
    variables: {
      actionId: action.id,
    },
  });

  const { t } = useTranslation("translation", {
    keyPrefix: "riseActionDetails.metrics",
  });

  let doneCount = action.metrics?.doneCount || 0;
  let notDoneCount = action.metrics?.notDoneCount || 0;
  let skippedCount = action.metrics?.skippedCount || 0;

  if (data?.node?.__typename === "RiseUserAction") {
    const metrics = data?.node?.metrics;
    doneCount = metrics?.doneCount || 0;
    skippedCount = metrics?.skippedCount || 0;
    notDoneCount = metrics?.notDoneCount || 0;
  }
  const completed = doneCount + skippedCount;
  const total = completed + notDoneCount;
  const percent = total > 0 ? completed / total : 0;

  return (
    <div className="flex shrink-0 grow items-center border-l px-8 py-4">
      <div className="w-full">
        <div
          className={`${theme?.progressBg} h-2 w-full overflow-hidden rounded`}
        >
          <div
            className={`${theme?.progress} h-full`}
            style={{ width: `${percent * 100}%` }}
          ></div>
        </div>
        <div className="mt-4 flex justify-center gap-6">
          <MetricDataPoint title={t("notDone")} count={notDoneCount} />
          <MetricDataPoint title={t("done")} count={doneCount || 0} />
          <MetricDataPoint title={t("skipped")} count={skippedCount} />
        </div>
      </div>
    </div>
  );
};

const MetricDataPoint = ({
  title,
  count,
}: {
  title: string;
  count: number;
}) => {
  return (
    <div className="flex flex-col items-center">
      <div className="mb-1 text-xl leading-5 font-bold">{count}</div>
      <div className="leading-5 text-muted-foreground">{title}</div>
    </div>
  );
};
